import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import PopupCss from "./PopupCss.js";
class Popup extends s {
  static get styles() {
    return [PopupCss];
  }
  static get properties() {
    return {
      direction: { type: String }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("click", () => this._hide());
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("click", () => this._hide());
  }
  static DIRECTION() {
    return {
      UP: "up",
      DOWN: "down",
      LEFT: "left",
      RIGHT: "right"
    };
  }
  constructor() {
    super();
    this.direction = "up";
  }
  render() {
    return y`
      <div class="popup-container">
        <slot @click="${(e) => this._show(e)}"
              name="wrapper">
        </slot>
        <div class="popup ${this.direction}"
             @click="${(event) => {
      event.stopPropagation();
    }}">
          <div class="triangle"></div>
          <div class="content">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    `;
  }
  _show(event) {
    if (event) {
      event.stopPropagation();
    }
    const popup = this.shadowRoot.querySelector(".popup");
    popup.style.display = "block";
  }
  _hide(event) {
    if (event) {
      event.stopPropagation();
    }
    const popup = this.shadowRoot.querySelector(".popup");
    popup.style.display = null;
  }
}
customElements.define("isceco-popup", Popup);
export { Popup as default };
